import * as _ from "lodash";
import * as $ from "jquery";
import { AccountPageInfo } from "../../apps/_BaseApp";
import { BaseInternalView } from "../_BaseViews";
import { DashboardAccountView } from "./dashboards/DashboardAccountView";
import { InstallAccountView } from "./installs/InstallAccountView";
import { MapsAccountView } from "./maps/MapsAccountView";
import { ReportsCollection } from "../../collections/Reports";
import { ReportAccountView } from "./reports/ReportAccountView";
import { TeamAccountView } from "./team/TeamAccountView";
import { UserAccountView } from "./user/UserAccountView";
import { UserCollection } from "../../collections/Users";
import { UserGroupCollection } from "../../collections/UserGroups";

require('bootstrap-toggle');

export class AccountView extends BaseInternalView {

    private subViews: BaseInternalView[] = [];
    private template = _.template(require('templates/account/genericAccount.html'));
    private accountLandingTemplate = _.template(require('templates/account/landing.html'));
    private accountIconTemplate = _.template(require('templates/account/accountIcon.html'));

    private userCollection: UserCollection = null;
    private userGroupCollection: UserGroupCollection = null;
    private reportsCollection = null;

    private collectionLoaded: boolean = false;
    private currentOrganizationId: number = null;


    constructor(options) {
        super(<any> _.extend(options, {
            tagName: 'div',
            events: {
                'click .account-tile-wrapper': 'handleAccountTileClick',
                'click .account-title': 'focusFilter',
                'input #account-filter-input': 'handleFilterChange',
                'input #breadcrumb-filter-input': 'handleBreadcrumbFilterChange',
                'input #table-filter-input': 'handleTableFilterChange',
            }
        }));
        this.handleFilterChange = _.debounce(this.handleFilterChange, 300);
        this.handleBreadcrumbFilterChange = _.debounce(this.handleBreadcrumbFilterChange, 300);
    }

    show(orgId, accountCategory?, itemId?, detail?, subDetail?, subDetailId?) {
        this.collectionLoaded = false;
        _.each(this.subViews, (v) => {
            v.remove()
        });

        if (!orgId) {
            this.currentOrganizationId = this.options.organizationCollection.first().get('id');
        } else {
            this.currentOrganizationId = Number(orgId);
        }

        this.render();

        this.userGroupCollection = new UserGroupCollection([], {organizationId: this.currentOrganizationId});
        this.userCollection = new UserCollection([], {organizationId: this.currentOrganizationId});
        this.reportsCollection = new ReportsCollection();

        var deferreds = [
            this.userCollection.getCollectionFetchPromise(),
            this.userGroupCollection.getCollectionFetchPromise(),
            this.reportsCollection.getCollectionFetchPromise()
        ];

        var when = $.when.apply($, deferreds);

        if (!accountCategory) {
            return when.then(() => {
                var deferreds = _.map(
                    this.options.appCollection.where({
                        organization_id: this.currentOrganizationId,
                        enabled: 1
                    }),
                    (m) => {
                        return this.options.appRegistry.getInstance(m.get('type'));
                    });
                return $.when.apply($, deferreds)
            }).then((...appInstances) => {
                return $.when.apply($, _.map(appInstances, (appInstance) => {
                    return appInstance.getAccountPage(this.currentOrganizationId);
                }));
            }).done((...acctInfo: AccountPageInfo[]) => {
                this.collectionLoaded = true;
                this.render();
                this.renderAccountCategories(acctInfo);
            });
        } else {
            return when.then(() => {
                this.collectionLoaded = true;
                this.render();
                return this.renderSubViews(accountCategory, itemId, detail, subDetail, subDetailId);
            });
        }
    }

    render() {
        this.$el.html(this.template({
            permissionCollection: this.options.permissionCollection,
            collectionLoaded: this.collectionLoaded,
            organizationCollection: this.options.organizationCollection,
            currentOrganizationId: this.currentOrganizationId,
            urlAddon: '',
            userIsOrgAdmin: true
        }));
        return this;
    }

    renderAccountCategories(accountInfos: AccountPageInfo[]) {
        this.$el.find('.container').append(this.accountLandingTemplate());

        var dashboards = this.options.dashboardCollection.where({organization_id: this.currentOrganizationId});
        var installs = this.options.installCollection.where({organization_id: this.currentOrganizationId});
        var reports = this.reportsCollection.where({organization_id: this.currentOrganizationId});

        var icons = [{
            icon: require('../../../img/account/users.svg'),
            label: this.userCollection.length + ' User' + (this.userCollection.length !== 1 ? 's' : ''),
            currentOrganizationId: this.currentOrganizationId,
            urlAddon: 'users'
        }, {
            icon: require('../../../img/account/teams.svg'),
            label: this.userGroupCollection.length + ' Team' + (this.userGroupCollection.length !== 1 ? 's' : ''),
            currentOrganizationId: this.currentOrganizationId,
            urlAddon: 'teams'
        }, {
            icon: require('../../../img/account/dashboards.svg'),
            label: dashboards.length + ' Dashboard' + (dashboards.length !== 1 ? 's' : ''),
            currentOrganizationId: this.currentOrganizationId,
            urlAddon: 'dashboards'
        }, {
            icon: require('../../../img/account/installs.svg'),
            label: installs.length + ' Installation' + (installs.length !== 1 ? 's' : ''),
            currentOrganizationId: this.currentOrganizationId,
            urlAddon: 'installs'
        }, {
            icon: require('../../../img/senseware/reportsIcon.svg'),
            label: reports.length + ' Report' + (reports.length !== 1 ? 's' : ''),
            currentOrganizationId: this.currentOrganizationId,
            urlAddon: 'reports'
        }, {
            icon: require('../../../img/account/mapsIcon.svg'),
            label: 'Map View',
            currentOrganizationId: this.currentOrganizationId,
            urlAddon: 'mapview'
        }];
        _.each(accountInfos, (info) => {
            icons.push({
                icon: info.icon,
                label: info.count + ' ' + info.name + (info.count !== 1 ? 's' : ''),
                currentOrganizationId: this.currentOrganizationId,
                urlAddon: info.type
            })
        });

        _.each(icons, (options) => {
            this.$el.find('.account-categories').append(this.accountIconTemplate(options));
        })
    }

    handleAccountTileClick(e) {
        window.location.hash = '/account/' + this.currentOrganizationId + '/' + $(e.currentTarget).attr('data-url');
    }

    renderSubViews(category, item?, detail?, subDetail?, subDetailId?) {
        var options = _.extend({}, this.options, {
            currentOrganizationId: this.currentOrganizationId,
            userGroupCollection: this.userGroupCollection,
            userCollection: this.userCollection,
            reportsCollection: this.reportsCollection
        });

        var deferred = $.Deferred();
        switch (category) {
            case 'users':
                deferred.resolve(new UserAccountView(options));
                break;
            case 'teams':
                deferred.resolve(new TeamAccountView(options));
                break;
            case 'dashboards':
                deferred.resolve(new DashboardAccountView(options));
                break;
            case 'installs':
                deferred.resolve(new InstallAccountView(options));
                break;
            case 'reports':
                deferred.resolve(new ReportAccountView(options));
                break;
            case 'mapview':
                deferred.resolve(new MapsAccountView(options));
                break;
            default:
                deferred = this.options.appRegistry.getInstance(category).then((appInstance) => {
                    return appInstance.getAccountView(options)
                })
        }

        $.when(deferred).then((subView) => {
            if (subView) {
                this.render();
                this.subViews.push(subView);
                this.$el.empty().append(subView.render().$el);
                subView.show(this.currentOrganizationId, item, detail, subDetail, subDetailId);
            }
        });
    }

    focusFilter() {
        setTimeout(() => {
            this.$('#account-filter-input').focus()
        }, 200);
    }

    handleFilterChange() {
        var lis = this.$('#account-filter-dropdown .height-limited-nav-dropdown li').get();
        var filter = (<string> this.$('#account-filter-input').val()).toLowerCase();
        _.each(lis, (li) => {
            var org = $(li).attr('data-org-name').toLowerCase();
            if (org.indexOf(filter) !== -1) {
                $(li).removeClass('hidden');
                this.currentOrganizationId = Number($(li).attr('data-org-name'));
            } else {
                $(li).addClass('hidden');
            }
        });
    }

    handleBreadcrumbFilterChange() {
        var lis = this.$('#breadcrumb-filter-dropdown .height-limited-nav-dropdown.filterable li').get();
        var filter = (<string> this.$('#breadcrumb-filter-input').val()).toLowerCase();
        _.each(lis, (li) => {
            var org = $(li).attr('data-breadcrumb').toLowerCase();
            if (org.indexOf(filter) !== -1) {
                $(li).removeClass('hidden');
                this.currentOrganizationId = Number($(li).attr('data-org-name'));
            } else {
                $(li).addClass('hidden');
            }
        });
    }

    remove() {
        _.each(this.subViews, (v) => {
            v.remove()
        });
        return super.remove();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/account/AccountView.ts